"use client"

import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Button,
    Container,
    Grid,
} from "@mui/material"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import PrintIcon from "@mui/icons-material/Print"
import { useEffect, useRef, useState } from "react"
import { Images } from "assets"
import SystemServices from "services/System"
import { useLocation } from "react-router-dom"
import moment from "moment"
import CustomerServices from "services/Customer"

export default function InvoicePage() {
    const invoiceRef = useRef(null)
    const [charges, setCharges] = useState(null)
    const [rates, setRates] = useState(null)
    const { state } = useLocation()
    console.log(state, 'statestate');


    const handlePrint = () => {
        window.print()
    }


    const getData = async (formData) => {

        console.log(formData);
        try {
            let params = {
                charges_type: 'rate'

            }

            const { data } = await SystemServices.getRates(params);
            console.log(data);
            let details = data?.charges
            setRates(data?.breakdown)


        } catch (error) {

        }
    }
      const getData2 = async (id) => {
       
      
        try {
          let params = {
            customer_id: id
    
          }
    
          const { data } = await CustomerServices.getCustomerDetail(params);
          console.log(data,'Element');
          
         let Element = data?.details?.charges?.find(
                (item) =>
                    item?.visa_type?.toLowerCase()?.includes(state?.item?.visa_type?.toLowerCase())

            );
            console.log(Element, 'Element');

            setCharges(Element)
    
        } catch (error) {
    
        } 
      }
    const dummyData = {
        company: {
            name: "AlMarin Documents Clearing Services Est.",
            address: "Office E-04, Level M",
            street: "Fronds Building, Sheikh Zayed Road",
            city: "DUBAI 00000",
            phone: "+971502224033",
            email: "zulqarnain.arshad@outlook.com",
            website: "www.almarinbusiness.com",
            uid: "Govt. UID 1316744",
        },
        invoice: {
            number: "MD/IMV/" + state?.item?.visa_request?.id,
            date: moment(state?.item?.visa_request?.created_at).format('DD-MM-YYYY'),
            dueDate: state?.item?.visa_request?.customer?.due_date_policy === 'Instant'
                ? moment(state?.item?.visa_request?.created_at).format('DD-MM-YYYY')
                : moment(state?.item?.visa_request?.created_at)
                    .add(
                        parseInt(state?.item?.visa_request?.customer?.due_date_policy?.match(/\d+/)?.[0] || 0),
                        'days'
                    )
                    .format('DD-MM-YYYY'),
            terms: state?.item?.visa_request?.customer?.due_date_policy,
        },
        billTo: {
            company: state?.item?.visa_request?.customer?.name,
        },
        shipTo: {
            company: state?.item?.visa_request?.customer?.name,
        },
        items: [
            {
                service: "Offer letter",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.offer_letter) || 0,
                amount: parseFloat(charges?.offer_letter) || 0,
            },
            {
                service: "Labour insurance",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.labour_insurance) || 0,
                amount: parseFloat(charges?.labour_insurance) || 0,
            },
            {
                service: "Labour Card Fees",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.labour_card_fees) || 0,
                amount: parseFloat(charges?.labour_card_fees) || 0,
            },
            {
                service: "Entry Permit",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.entry_permit) || 0,
                amount: parseFloat(charges?.entry_permit) || 0,
            },
            {
                service: "Change status",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.change_status) || 0,
                amount: parseFloat(charges?.change_status) || 0,
            },
            {
                service: "Medical",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.medical) || 0,
                amount: parseFloat(charges?.medical) || 0,
            },
            {
                service: "Emirates id typing",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.emirates_id_typing) || 0,
                amount: parseFloat(charges?.emirates_id_typing) || 0,
            },
            {
                service: "Visa Stamping",
                description: `${state?.item?.name} - ${state?.item?.passport_number}`,
                qty: 1,
                rate: parseFloat(charges?.visa_stamping) || 0,
                amount: parseFloat(charges?.visa_stamping) || 0,
            },
        ],
        bank: {
            accountHolder: "ALMARIN DOCUMENTS CLEARING SERVICES EST.",
            iban: "AE620860000009285033439",
            bic: "WIOBAEADXXX",
        },
        balanceDue: parseFloat(charges?.offer_letter || 0) + parseFloat(charges?.visa_stamping || 0) + parseFloat(charges?.emirates_id_typing || 0) + parseFloat(charges?.medical || 0) + parseFloat(charges?.change_status || 0) + parseFloat(charges?.entry_permit || 0) + parseFloat(charges?.labour_card_fees || 0) + parseFloat(charges?.labour_insurance || 0),
    }
    useEffect(() => {
        getData()
    }, [])

    const handleDownloadPDF = async () => {
        try {
            const { default: html2pdf } = await import("html2pdf.js")
            const element = invoiceRef.current
            const opt = {
                margin: 5,
                filename: `invoice-${dummyData.invoice.number}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { orientation: "portrait", unit: "mm", format: "a4" },
            }
            html2pdf().set(opt).from(element).save()
        } catch (error) {
            console.log("[v0] PDF download error:", error)
        }
    }
    useEffect(() => {
        if (state) {
            getData2(state?.item?.customer_id)

        }

    }, [])


    return (
        <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", py: 2 }}>
            <Container maxWidth="lg">
                <Box sx={{ display: "flex", gap: 2, mb: 2, justifyContent: "flex-end" }}>
                    {/* <Button
                        variant="contained"
                        startIcon={<PrintIcon />}
                        onClick={handlePrint}
                        sx={{
                            backgroundColor: "#2c5b8f",
                            textTransform: "none",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": { backgroundColor: "#1e3f5a" },
                        }}
                    >
                        Print
                    </Button> */}
                    <Button
                        variant="outlined"
                        startIcon={<FileDownloadIcon />}
                        onClick={handleDownloadPDF}
                        sx={{
                            borderColor: "#2c5b8f",
                            color: "#2c5b8f",
                            textTransform: "none",
                            fontSize: "14px",
                            fontWeight: 600,
                        }}
                    >
                        Download PDF
                    </Button>
                </Box>

                <Paper
                    ref={invoiceRef}
                    elevation={2}
                    sx={{
                        p: 3,
                        backgroundColor: "white",
                        maxWidth: "900px",
                        mx: "auto",
                        fontSize: "14px",
                    }}
                >
                    {/* Header Section */}
                    <Box sx={{ textAlign: "center", mb: 3, pb: 2, borderBottom: "2px solid #e0e0e0" }}>

                        <img
                            style={{ width: "100px", height: "100px" }}
                            src={Images.pdfLogo}
                        />



                    </Box>

                    {/* Company Info */}
                    <Box sx={{ textAlign: "center", mb: 3 }}>
                        <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#155368", mb: 0.5 }}>
                            {dummyData.company.name}
                        </Typography>
                        <Typography sx={{ fontSize: "11px", color: "#333", mb: 0.3 }}>{dummyData.company.address}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#333", mb: 0.3 }}>{dummyData.company.street}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#333", mb: 0.75 }}>{dummyData.company.city}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#666" }}>{dummyData.company.phone}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#666" }}>{dummyData.company.email}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#666", mb: 0.75 }}>{dummyData.company.website}</Typography>
                        <Typography sx={{ fontSize: "11px", color: "#155368", fontWeight: 600 }}>
                            {dummyData.company.uid}
                        </Typography>
                    </Box>

                    {/* Bill To / Ship To / Invoice Details */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ border: "1px solid #ddd", p: 1.5, backgroundColor: "#f9f9f9" }}>
                                <Typography
                                    sx={{ fontSize: "11px", fontWeight: 700, mb: 0.75, borderBottom: "2px solid #155368", pb: 0.75 }}
                                >
                                    BILL TO
                                </Typography>
                                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>{dummyData.billTo.company}</Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box sx={{ border: "1px solid #ddd", p: 1.5, backgroundColor: "#f9f9f9" }}>
                                <Typography
                                    sx={{ fontSize: "11px", fontWeight: 700, mb: 0.75, borderBottom: "2px solid #155368", pb: 0.75 }}
                                >
                                    SHIP TO
                                </Typography>
                                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>{dummyData.shipTo.company}</Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "#666" }}>INVOICE</Typography>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>{dummyData.invoice.number}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "#666" }}>DATE</Typography>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>{moment(dummyData.invoice.date).format('DD-MM-YYYY')}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "#666" }}>TERMS</Typography>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>{dummyData.invoice.terms}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "#666" }}>DUE DATE</Typography>
                                    <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>{moment(dummyData.invoice.dueDate).format('DD-MM-YYYY')}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Items Table */}
                    <TableContainer sx={{ mb: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                    <TableCell
                                        sx={{ fontSize: "11px", fontWeight: 700, color: "#333", borderBottom: "2px solid #ddd", py: 1 }}
                                    >
                                        DATE
                                    </TableCell>
                                    <TableCell
                                        sx={{ fontSize: "11px", fontWeight: 700, color: "#333", borderBottom: "2px solid #ddd", py: 1 }}
                                    >
                                        SERVICE
                                    </TableCell>
                                    <TableCell
                                        sx={{ fontSize: "11px", fontWeight: 700, color: "#333", borderBottom: "2px solid #ddd", py: 1 }}
                                    >
                                        DESCRIPTION
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            color: "#333",
                                            borderBottom: "2px solid #ddd",
                                            py: 1,
                                            width: "50px",
                                        }}
                                    >
                                        QTY
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            color: "#333",
                                            borderBottom: "2px solid #ddd",
                                            py: 1,
                                            width: "80px",
                                        }}
                                    >
                                        RATE
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            color: "#333",
                                            borderBottom: "2px solid #ddd",
                                            py: 1,
                                            width: "80px",
                                        }}
                                    >
                                        AMOUNT
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dummyData.items.map((item, index) => (
                                    <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                                        <TableCell sx={{ fontSize: "10px", color: "#333", py: 0.75, borderBottom: "1px solid #eee" }}>
                                            {moment(dummyData.invoice.date).format('DD-MM-YYYY')}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: "10px", color: "#333", py: 0.75, borderBottom: "1px solid #eee" }}>
                                            {item.service}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: "10px", color: "#333", py: 0.75, borderBottom: "1px solid #eee" }}>
                                            {item.description}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ fontSize: "10px", color: "#333", py: 0.75, borderBottom: "1px solid #eee" }}
                                        >
                                            {item.qty}
                                        </TableCell>
                                        <TableCell
                                            align="right"
                                            sx={{ fontSize: "10px", color: "#333", py: 0.75, borderBottom: "1px solid #eee" }}
                                        >
                                            {item?.rate?.toFixed(2)}
                                        </TableCell>
                                        <TableCell
                                            align="right"
                                            sx={{
                                                fontSize: "10px",
                                                color: "#333",
                                                py: 0.75,
                                                borderBottom: "1px solid #eee",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item.amount.toFixed(2)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* System Generated Note */}
                    <Box sx={{ textAlign: "center", mb: 2, p: 1, backgroundColor: "#f0f0f0", borderRadius: 0.5 }}>
                        <Typography sx={{ fontSize: "10px", color: "#666", fontStyle: "italic" }}>
                            This is system generated invoice signature and stamp are not required
                        </Typography>
                    </Box>

                    {/* Balance Due and Bank Details */}
                    <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                        <Grid item xs={12} sm={5}>
                            <Box sx={{ border: "2px solid #155368", p: 1.5, textAlign: "center", backgroundColor: "#f0f7fb" }}>
                                <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#666", mb: 0.75 }}>Total</Typography>
                                <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#155368" }}>
                                    AED {dummyData.balanceDue.toFixed(2)}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={7}>
                            <Box sx={{ p: 1.5 }}>
                                <Typography sx={{ fontSize: "11px", fontWeight: 700, mb: 0.75, color: "#155368" }}>
                                    Account holder:
                                </Typography>
                                <Typography sx={{ fontSize: "10px", mb: 1, color: "#333" }}>{dummyData.bank.accountHolder}</Typography>
                                <Typography sx={{ fontSize: "11px", fontWeight: 700, mb: 0.5, color: "#155368" }}>IBAN:</Typography>
                                <Typography sx={{ fontSize: "10px", mb: 1, color: "#333", wordBreak: "break-all" }}>
                                    {dummyData.bank.iban}
                                </Typography>
                                <Typography sx={{ fontSize: "11px", fontWeight: 700, mb: 0.5, color: "#155368" }}>BIC:</Typography>
                                <Typography sx={{ fontSize: "10px", color: "#333" }}>{dummyData.bank.bic}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Footer with divider */}
                    <Box sx={{ borderTop: "2px solid #e0e0e0", pt: 1, textAlign: "center" }}>
                        <Typography sx={{ fontSize: "10px", color: "#666", fontStyle: "italic" }}>Powered By:MangoTechDevs.ae</Typography>
                    </Box>
                </Paper>
            </Container>

            <style jsx>{`
        @media print {
          body {
            background-color: white;
          }
          .MuiContainer-root {
            max-width: 100%;
          }
          button {
            display: none;
          }
          @page {
            size: A4;
            margin: 5mm;
          }
        }
      `}</style>
        </Box>
    )
}
